import React from 'react'
import { request } from '../helpers/request'
import Immutable from 'immutable'
import { t } from '../helpers/translate.js'
import { getOrg, isAdmin } from '../helpers/access'
import LoadingComponent from './common/LoadingComponent'
import ModalComponent from './common/ModalComponent';

let config = require('config');

class Documents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      documents: [],
      loading: false,
      loadingText: null,
      showModal: false,
      document_name: '',
      document_url: '',
      editDoc: null,
      deleteDocId: '',
    };
  }

  componentWillMount() {
    this.getDocuments();
  }

  handleDocumentNameChange(event) {
    this.setState({ document_name: event.target.value })
  }

  handleDocumentUrlChange(event) {
    this.setState({ document_url: event.target.value })
  }

  showModal(title, body, button, buttonAction) {
    this.setState({
      showModal: true,
      modalBody: t(body),
      modalTitle: t(title),
      resetDataOnClose: true,
      modalOptionalButton: t(button),
      modalAction: buttonAction
    }
    )
  }

  showLoading(text = null) {
    this.setState({
      loading: true,
      loadingText: text
    })
  }

  documentsUrl() {
    return `${config.default.api}/documents`;
  }

  validateField(doc) {
    if (doc == null || doc == "") {
      return false
    }
    return true
  }

  validateReqData() {
    const docName = this.state.document_name.trim();
    const docUrl = this.state.document_url.trim();
    let validateErrors = ""

    if (!this.validateField(docName)) {
      validateErrors += 'File Name';
    }
    if (!this.validateField(docUrl)) {
      validateErrors += (validateErrors === "") ? 'File URL' : ' and File URL'
    }
    if (validateErrors !== "") {
      this.showModal(t('Error'), t('Please enter ' + validateErrors));
      return false;
    }
    return true;
  }

  addEditRowSubmit = (editDoc) => {
    this.handleModalClose();
    if (!this.validateReqData()) {
      return false;
    }
    this.setState({
      loading: true,
      loadingText: t('Saving'),
    });

    const data = {
      row: {
        id: (editDoc ? editDoc.id : ''),
        document_name: this.state.document_name,
        document_url: this.state.document_url,
        org: getOrg()
      }
    }
    request(this.documentsUrl(),
      editDoc ? 'PUT' : 'POST', data,
      function (responseData, status) {
        if (status == 200) {
          const documents = Immutable.fromJS(responseData);
          const statusMessage = editDoc ? 'updated' : 'added'
          this.setState({
            data: documents.toJS(),
            loading: false,
          })
          this.showModal(t('Success'), t(`Your document has been ${statusMessage}`));
        } else {
          this.showModal(t('Error'), responseData.messages.map((message) => <p>{message}</p>));
        }
      }.bind(this)
    );
  }

  getDocuments = () => {
    this.setState({
      loading: true,
      loadingText: t('Loading'),
    });

    request(this.documentsUrl(),
      'GET', null,
      function (responseData, status) {
        if (status == 200) {
          this.setState({
            documents: responseData.documents,
            loading: false
          })
        } else {
          this.showModal(t('Error'), responseData.messages.map((message) => <p>{message}</p>));
        }
      }.bind(this)
    );
  }

  handleAddRow = (doc) => {
    this.setState({
      editDoc: doc,
      document_name: doc ? doc.document_name : '',
      document_url: doc ? doc.document_url : '',
    });
    this.showModal(t('Document Management'), this.showAddEditModal(doc), (doc ? t('Update'): t('Save')), this.addEditRowSubmit.bind(this, doc))
  };

  handleRemoveRow = (id) => {
    this.setState({
      deleteDocId: id
    });
    this.showModal(t('Delete File'), this.showDeleteModal(), t('Confirm'), this.deleteRow.bind(this))
  };

  handleModalClose() {
    this.setState({
      editDoc: null,
      showModal: false,
    })
    this.getDocuments();
  }

  deleteRow() {
    this.setState({
      loading: true,
      loadingText: t('Deleting'),
    });

    const data = {
      row: {
        id: this.state.deleteDocId,
      }
    }
    request(this.documentsUrl(),
      'DELETE', data,
      function (responseData, status) {
        if (status == 200) {
          this.showModal(t('Success'), t('Your document has been deleted'));
          this.setState({
            loading: false,
          })
        } else {
          const errorMessage = responseData.messages.map((message) => <p>{message}</p>);
          this.showModal(t('Error'), errorMessage);
        }
      }.bind(this)
    )
  }

  showNoDocumentsText() {
    if (!this.state.loading && this.state.documents.length === 0) {
      return <h4 className='div-center'>{t('No Documents are available')}</h4>
    }
  }

  showTableRows() {
    const updatedRows = this.state.documents;
    return (<div>{this.showNoDocumentsText()}
      <table className="table table-hover" id="tab_logic">
        <tbody>
          {updatedRows && updatedRows.map((document, index) => (
            <tr key={index}>
              <td>
                <h4><a href={document.document_url} target="_blank">{document.document_name}</a></h4>
              </td>
              <td>
                {isAdmin() &&
                  <div className="btn-group pull-right mobile-pull-right">
                    <span onClick={this.handleAddRow.bind(this, document)} className="fa fa-pencil-square-o fa-lg table-icons"></span>
                    <span onClick={this.handleRemoveRow.bind(this, document.id)} className="fa fa-trash fa-lg table-icons"></span>
                  </div>
                }
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>)
  }

  showDeleteModal() {
    return <span className='text-center'>
      <div className="mobile-top-padding">
        <span className="fa fa-exclamation-triangle fa-lg"></span>
      </div>
      <h4 className='table-icons'>{t('Are you sure you want to delete this file?')}</h4>
    </span>
  }

  showAddEditModal(editDoc) {
    return <div>
      <table className="table table-bordered table-hover" id="tab_logic">
        <thead>
          <tr>
            <th className="text-left">{t('File Name')}</th>
            <th className="text-left">{t('File URL')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <input type="text" {...(editDoc ? { defaultValue: editDoc.document_name } : {})} name="document_name" onChange={this.handleDocumentNameChange.bind(this)} className="form-control" />
            </td>
            <td>
              <input type="text" {...(editDoc ? { defaultValue: editDoc.document_url } : {})} name="document_url" onChange={this.handleDocumentUrlChange.bind(this)} className="form-control" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  }

  render() {
    return (
      <div>
        <div className="container">
          <h2 className='page-title row div-center'>{t('Documents')}</h2>
          <br />
          <div className="row">
            <div className="margin-auto col-md-12">
              {this.showTableRows()}
              {isAdmin() &&
                <button onClick={this.handleAddRow.bind(this, null)} className="btn btn-default pull-right"><span className="fa fa-plus fa-lg btn-icon"></span>{t('Add')}</button>
              }
            </div>
          </div>
        </div>

        <ModalComponent
          title={this.state.modalTitle}
          body={this.state.modalBody}
          onClose={this.handleModalClose.bind(this)}
          onSubmit={this.state.modalAction}
          show={this.state.showModal}
          resetDataOnClose={this.state.resetDataOnClose}
          buttonName = {this.state.modalOptionalButton}
        />

        <LoadingComponent show={this.state.loading} text={this.state.loadingText} />
      </div>
    );
  }
}

Documents.displayName = 'Documents';
export default Documents;


// WEBPACK FOOTER //
// ./src/components/Documents.js